var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16943_17235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 5.83301V0.833008H14.1667",
    stroke: "#2F0248",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66634L19.1666 0.833008",
    stroke: "#2F0248",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 14.1004V16.6004C18.3344 16.8325 18.2868 17.0622 18.1939 17.2749C18.1009 17.4875 17.9645 17.6784 17.7935 17.8353C17.6225 17.9922 17.4206 18.1116 17.2007 18.186C16.9809 18.2603 16.7479 18.288 16.5168 18.2671C13.9525 17.9884 11.4893 17.1122 9.32511 15.7087C7.31163 14.4293 5.60455 12.7222 4.32511 10.7087C2.91676 8.53474 2.04031 6.05957 1.76677 3.48374C1.74595 3.2533 1.77334 3.02104 1.84719 2.80176C1.92105 2.58248 2.03975 2.38098 2.19575 2.21009C2.35174 2.0392 2.54161 1.90266 2.75327 1.80917C2.96492 1.71569 3.19372 1.66729 3.42511 1.66707H5.92511C6.32953 1.66309 6.7216 1.80631 7.02824 2.07002C7.33488 2.33373 7.53517 2.69995 7.59177 3.10041C7.69729 3.90046 7.89298 4.68601 8.17511 5.44207C8.28723 5.74034 8.31149 6.0645 8.24503 6.37614C8.17857 6.68778 8.02416 6.97383 7.80011 7.20041L6.74177 8.25874C7.92807 10.345 9.65549 12.0724 11.7418 13.2587L12.8001 12.2004C13.0267 11.9764 13.3127 11.8219 13.6244 11.7555C13.936 11.689 14.2602 11.7133 14.5584 11.8254C15.3145 12.1075 16.1001 12.3032 16.9001 12.4087C17.3049 12.4658 17.6746 12.6697 17.9389 12.9817C18.2032 13.2936 18.3436 13.6917 18.3334 14.1004Z",
    stroke: "#2F0248",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16943_17235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.ae315f12d66775ce4ae59bd6b9c10f25.svg";